import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../util/Localizer'
import ClaimTypeButton from '../../controls/claimTypeButton'
import Card from '@material-ui/core/Card'
import { fetchBenefitTypes } from '../../redux/actions/submitExpenseActions'
import { clearSelectedPractioner } from '../../redux/actions/submitPractitionerActions'
import { clearClaimExpenses } from '../../redux/actions/submitAClaimActions'
import { ClaimTypes } from '../../redux/SubmitClaim/Common'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Loading from '../../widgets/Loading'
import SubmitEmptyState from '../../widgets/SubmitAClaim/SubmitEmptyState'
import { passMessage } from '../../redux/actions/submitNavigationActions'
import extractServiceItems from '../../util/ExtractServiceItems'

const photoUpload = 'photoUpload'

class ClaimTypeBenefit extends Component {
  constructor (props) {
    super(props)

    this.updateNext = this.updateNext.bind(this)
    this.shouldShowEmptyState = this.shouldShowEmptyState.bind(this)

    const { claimObj = {} } = props
    const { type = ClaimTypes.UNKNOWN } = claimObj

    this.state = {
      type,
      categoryCode: '',
      serviceItems: []
    }
  }

  componentDidMount () {
    if (this.props.claimObj.categoryCode) {
      const { claimObj } = this.props
      const { benefitTypes = [] } = this.props.benefitTypes || {}

      this.setState({
        categoryCode: claimObj.categoryCode,
        type: claimObj.type,
        serviceItems: extractServiceItems(claimObj, benefitTypes)
      })
    }

    this.props.updateUrl(null)
    this.props.setNext(null)
    this.props.setPercent(40)
    this.props.fetchBenefitTypes()

    this.initializeFiles()
  }

  componentDidUpdate () {
    this.updateNext()
  }

  shouldShowEmptyState () {
    return (this.state.type === 'general' || this.state.type === 'dentalAccident' || this.state.type === 'EHC Non Web Service')
  }

  initializeFiles () {
    if (!this.shouldShowEmptyState()) {
      const files = this.props.claimObj.ImageContent || []
      if (files.length > 0) {
        this.props.updateClaim({
          claimSubmitType: photoUpload
        })
      }

      setTimeout(() => this.updateNext())
    } else {
      this.props.updateClaim({ ImageContent: [] })
    }
  }

  selectType (e) {
    let type = ''
    if (e.name) {
      type = e.nameEnglish
    } else {
      type = e
    }
    if (type !== this.state.type) {
      this.props.clearSelectedPractioner()
      this.props.clearClaimExpenses()
    }

    this.setState({ type: type }, () => this.updateNext())

    const t = type === 'general' ? 'EHC Non Web Service' : type

    this.props.updateClaim({
      searchName: e.nameEnglish || t || '',
      type: t,
      categoryCode: e.categoryCode,
      ClinicType: e.name || t,
      claimSubmitType: ''
    })
  }

  claimFiles () {
    if (this.props.claimObj) {
      return this.props.claimObj.ImageContent || []
    } else {
      return []
    }
  }

  updateNext () {
    const { claimObj = {} } = this.props
    if (claimObj.claimSubmitType === photoUpload) {
      this.props.setNext('certifcationAndAuthorization')
    } else if (this.state.type !== ClaimTypes.UNKNOWN && !this.shouldShowEmptyState()) {
      this.props.setNext('submitOption')
    } else {
      this.props.setNext(null)
    }
  }

  render () {
    return (
      <Card className='submitCard'>
        <Row start='xs'>
          <Col xs={12}>
            <h3>{localize('pages.SubmitAClaim.NewClaim.Title')}</h3>
            <p>
              {
                this.shouldShowEmptyState()
                  ? localize('pages.SubmitAClaim.NewClaim.submitReceipt')
                  : localize('pages.SubmitAClaim.NewClaim.selectBenefitType')
              }
            </p>
          </Col>
        </Row>
        <br /><br />
        {this.shouldShowEmptyState()
          ? <SubmitEmptyState
            memberSummary={this.props.memberSummary}
            type={this.state.type}
            dentalAccident
            setNext={this.props.setNext}
            updateClaim={this.props.updateClaim}
            next={'certifcationAndAuthorization'}
            passMessage={this.props.passMessage}
            reason={this.state.type}
            initialFileList={this.claimFiles()}
          />
          : <Row center='xs'><Col xs={12}>
            <Row around='xs' middle='xs'>
              {this.props.benefitTypeLoading ? <Loading /> : null}
              {this.props.benefitTypes
                ? this.props.benefitTypes.benefitTypes.map((m, i) => {
                  return (
                    <Col key={i} xs={12} sm={8} md={4} lg={3}>
                      <ClaimTypeButton props={m} onClick={(e) => this.selectType(e)} primary={this.state.type} selected={this.state} />
                      <br />
                    </Col>
                  )
                })
                : null}
            </Row>
          </Col>
          </Row>
        }
      </Card>
    )
  }
}

function mapStateToProps (state) {
  return {
    benefitTypeLoading: state.SubmitExpenseReducer.benefitTypeLoading || false,
    benefitTypes: state.SubmitExpenseReducer.benefitTypes || null,
    benefitTypeError: state.SubmitExpenseReducer.benefitTypeError || null,
    memberSummary: state.memberSummaryReducer.memberSummary,
    claimObj: state.SubmitAClaimReducer.claimObj || {}
  }
}
const ConnectedClaimTypeBenefit = connect(mapStateToProps, {
  fetchBenefitTypes,
  clearSelectedPractioner,
  clearClaimExpenses,
  passMessage })(injectIntl(ClaimTypeBenefit))

export default ConnectedClaimTypeBenefit



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/ClaimTypeBenefitSelect.js